import { Grid } from '@mui/material';

import { FormAutocompleteField, FormDateField, FormTextField } from '../../../../../common';
import {
  MEDICAL_DIAGNOSIS_FIELD_OPTIONS,
  MEDICAL_DIAGNOSIS_STATE_OPTIONS,
} from './constants';

import type { DiagnosisFieldsProps } from './types';

export default function DiagnosisFields({
  backgroundColor,
  disabled,
  formik,
  readOnly,
  saveField,
}: DiagnosisFieldsProps) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="Diagnosis"
          name="diagnosis_name"
          onChange={saveField}
          options={MEDICAL_DIAGNOSIS_FIELD_OPTIONS}
          placeholder="Select diagnosis"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="Provider name"
          name="provider_name"
          onBlur={saveField}
          placeholder="Enter provider name"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <FormTextField
          disabled={disabled}
          formik={formik}
          label="City"
          name="city"
          onBlur={saveField}
          placeholder="Enter city"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={6} sm={3} md={2}>
        <FormAutocompleteField
          disabled={disabled}
          formik={formik}
          label="State"
          name="state"
          onChange={saveField}
          options={MEDICAL_DIAGNOSIS_STATE_OPTIONS}
          placeholder="Select state"
          readOnly={readOnly}
          required
        />
      </Grid>
      <Grid item xs={6} sm={3} md={2}>
        <FormDateField
          backgroundColor={backgroundColor}
          disabled={disabled}
          formik={formik}
          format="YYYY"
          label="Year"
          name="year"
          onChange={saveField}
          picker="year"
          placeholder="Diagnosis year"
          readOnly={readOnly}
          required
        />
      </Grid>
    </Grid>
  );
}
